import { render, staticRenderFns } from "./AddRequestSms.vue?vue&type=template&id=15dcb25f&scoped=true&"
import script from "./AddRequestSms.vue?vue&type=script&lang=js&"
export * from "./AddRequestSms.vue?vue&type=script&lang=js&"
import style0 from "./AddRequestSms.vue?vue&type=style&index=0&id=15dcb25f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dcb25f",
  null
  
)

component.options.__file = "AddRequestSms.vue"
export default component.exports